<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[1]" :innerTitle="navList[1].navChildList[2].name" :innerLink="navList[1].navChildList[2].toLink"></inner-nav>
      <div class="culture-content">
        <div class="culture-title">
          <h1>企业文化</h1>
          <h3>CORPORATE CULTURE</h3>
        </div>
        <ul class="culture-detail">
          <li v-for="(item,index) in cultureList" :key="index">
            <img :src="item.imgUrl" alt="">
            <div>
              <p>{{item.title}}</p>
              <span>{{item.content}}</span>
            </div>
          </li>
        </ul>



      </div>

    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  export default {
    name: "",
    data(){
      return {
        cultureList: {}
      }
    },
    components: {
      ad,
      InnerNav
    },
    created(){
      this.$http.get(`/outer/concept/listConcepts.do`,{
        functionCode:3
      }).then((res)=>{
        this.cultureList=res.data
      })
    }
  }
</script>

<style scoped lang="less">
  .culture-content{
    padding-top:.3rem;
    width:12rem;
      .culture-title{
        padding-bottom:.3rem;
          h1{
            font-size:.24rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:.48rem;
          }
          h3{
            font-size:.14rem;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:.14rem;
          }
      }
      .culture-detail{
        clear: both;
        overflow: hidden;
        padding-bottom:.5rem;
        width:100%;
          li{
            overflow: hidden;
            float: left;
            position: relative;
              img{
                position: absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;
              }
              div{
                font-family:PingFangSC-Regular;
                position: absolute;
                bottom:0;
                left:0;
                width:100%;
                height:.9rem;
                z-index: 2;
                background:rgba(0,0,0,0.5);
                color: #fff;
                box-sizing: border-box;
                padding: .2rem .4rem;
                  p{
                    font-size:.18rem;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:.24rem;
                  }
                  span{
                    font-size:.14rem;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:.24rem;
                  }
              }
          }
          li:hover{
            img{
              animation:scaleDraw 2s ease-in-out 0s 1 alternate forwards;
            }

          }
          li:nth-child(1){
            width:8rem;
            height:4.9rem;
          }
          li:nth-child(2){
            width:4rem;
            height:4.9rem;
          }
          li:nth-child(3){
            width:4.6rem;
            height:2.6rem;
          }
          li:nth-child(4){
            width:7.4rem;
            height:2.6rem;
          }

      }
  }
  @keyframes scaleDraw {  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
    0%{
      transform: scale(1);  /*开始为原始大小*/
    }
    50%{
      transform: scale(1.1); /*放大1.1倍*/
    }
    100%{
      transform: scale(1);
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/group/culture.vue